import cloneDeep from 'lodash/cloneDeep';
import accessControlsMetaData from './accessControlsMetaData';

const accessControlsUtils = {
    createConfig: (oidcRoles) => {
        let config = cloneDeep(accessControlsMetaData);
        for (let i = 0; i < oidcRoles.length; i++) {
            if (config.roles[oidcRoles[i]]) {
                config.roles[oidcRoles[i]].active = true;
            }
        }
        return config;
    },
    checkRouteAccessBeforeEnter: (accessControlsConfig, routeRoles) => {
        let hasAccess = false;

        for (let i = 0; i < routeRoles.length; i++) {
            if (accessControlsConfig && accessControlsConfig.roles[routeRoles[i]].active) {
                hasAccess = true;
                break;
            }
        }

        return hasAccess;
    },
    secureRouteBeforeEnter(store, to, next) {
        let accessControlsConfig = store.getters['user/accessControlsConfig'];
        if (accessControlsUtils.checkRouteAccessBeforeEnter(accessControlsConfig, to.meta.roles)) {
            next();
        } else {
            next('/403');
        }
    },
};

export default accessControlsUtils;
